module.exports = __webpack_public_path__ + "img/img6.09979a5d.png";